module.exports = __webpack_public_path__ + "templates.destination-section.seven-eleven-5cd330f2.html";